// src/seo/HomeSEO.js
import { SEO_CONFIG } from './SEOConfig';

export const HomeSEOData = {
    // We use the defaults from Config, but you can override them here if needed
    title: SEO_CONFIG.defaultTitle,
    description: SEO_CONFIG.defaultDescription,

    // Strong keywords for the main page
    keywords: "Malayalam books, book publishing Kerala, Uyirmozhy, buy books online, self publishing Malayalam, best malayalam authors, online book store Kerala",

    url: SEO_CONFIG.baseUrl,

    // For the Home Page, the Identity (Organization) Schema is the most important
    schema: SEO_CONFIG.baseSchema
};